<template>
    <div>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            offset-y
            >
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
            </template>

            <v-card color="grey lighten-5">
                <v-list dense>
                    <!-- <v-subheader>Preferencias</v-subheader> -->
                    <!-- <v-divider></v-divider> -->
                    <v-list-item-group color="primary">
                        
                        <v-list-item @click="$emit('cambiarPass')">
                            <v-list-item-icon>
                                <v-icon>mdi-lock-reset</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cambiar contraseña</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-list-item @click="blockNotificacionesAction()">
                            <v-list-item-icon>
                                <v-icon v-if="!blockNotificaciones" class="icon-size">mdi-bell-off</v-icon>
                                <v-icon v-else class="icon-size">mdi-bell</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span v-if="!blockNotificaciones">Desactivar notificaciones</span>
                                    <span v-else>Activar notificaciones</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="cerrarSesion()">
                            <v-list-item-icon>
                                <v-icon v-if="!master">mdi-power</v-icon>
                                <v-icon v-else>mdi-account-switch</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-if="!master">Cerrar sesión</v-list-item-title>
                                <v-list-item-title v-else>Regresar a master</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
export default {
    props:['apps'],
    computed: {
        ...mapGetters(["httpURL","masterApp","sessionToken","blockNotificaciones","master"])
    },
    data: () => ({
        loading: false,
        fav: true,
        menu: false,
        message: false,
        hints: true
    }),
    methods:{
        blockNotificacionesAction(){
            this.loading = true;
            axios.put(this.httpURL+'/usuario/blockNotifcaciones/global',{},
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.loading = false;
                this.menu = false;
                if( res.data.ok ){
                    this.$store.dispatch("setBlockNotificaciones", res.data.blockNotificaciones);
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
        },
        cerrarSesion(){
            localStorage.removeItem("token");
            sessionStorage.removeItem("token");
            this.$store.dispatch("setSessionToken", null);
            if(!this.master) this.$router.push("/login");
            else window.open(`${this.masterApp}/apps`, "_self");
        }
    }
}
</script>